module.exports = __webpack_public_path__ + "img/game1.d9bf0161.png";